//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link } from 'react-router-dom'
import Footer from '../components/UIElements/Footer'
import SearchByTeam from '../components/UIElements/SearchByTeam'
import FilterByTeam from '../components/UIElements/FilterByTeam'
import SearchByLeagueOrVenue from '../components/UIElements/SearchByLeagueOrVenue'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import SelectLeagueSchedule from '../components/UIElements/SelectLeagueSchedule'
//import { FaUsers } from 'react-icons/fa'
import sLogo from '../../images/s_logo_png.png'
//import FilterByTeam from '../components/UIElements/FilterByTeam'
import brookline from '../../images/brookline.png'
import cranberry from '../../images/cranberry.PNG'
import falcons from '../../images/falcons.png'
import latrobe from '../../images/latrobe.PNG'
import mckeesport from '../../images/mckeesport.PNG'
import murrysville from '../../images/murrysville.png'
import newKen from '../../images/newKen.png'
import pennHills from '../../images/pennHills.PNG'
import riverview from '../../images/riverview.PNG'
import southHills from '../../images/southHills.png'
import teamPitt from '../../images/teamPitt.png'
import venom from '../../images/venom.png'
import bridgeville from '../../images/bridgeville.PNG'
import eggHarbor from '../../images/eggHarbor.PNG'
import gtha from '../../images/gtha.png'
import leominster from '../../images/leominster.png'
import mapleShade from '../../images/mapleShade.PNG'
import marlton from '../../images/marlton.PNG'
import maysLanding from '../../images/maysLanding.PNG'
import medfordRenegades from '../../images/medfordRenegades.PNG'
import nymenace from '../../images/nymenace.png'
import scottTownship from '../../images/scottTownship.PNG'
import westDeptford from '../../images/westDeptford.PNG'
import bellmawr from '../../images/bellmawr.PNG'
import athol from '../../images/athol.PNG'
import monroe from '../../images/monroe.PNG'
import fitchburg from '../../images/fitchburg.PNG'
import pa from '../../images/PA.png'
import tricounty from '../../images/tri_county.png'

const TeamSchedule = () => {
	console.log('inside TeamSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	//const [teamId, setTeamId] = useState()
	const [leagueId, setLeagueId] = useState()
	const [wins, setWins] = useState()
	const [losses, setLosses] = useState()
	const [overtimeLosses, setOvertimeLosses] = useState()
	const [shootoutLosses, setShootoutLosses] = useState()
	const [ties, setTies] = useState()
	const [allTeamGames, setAllTeamGames] = useState([])
	const [divisionName, setDivisionName] = useState()
	const [leagueName, setLeagueName] = useState()
	const [teamName, setTeamName] = useState()
	const [allPotentialPlayoffGames, setAllPotentialPlayoffGames] = useState()
	const [allGameStats, setAllGameStats] = useState()
	const [pimAsTieBreaker, setPimAsTieBreaker] = useState()
	const [showCalendarSyncModal, setShowCalendarSyncModal] = useState(false)
	//
	const isIOS =
		/iPad|iPhone|iPod/.test(navigator.userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

	const isAndroid = /Android/i.test(navigator.userAgent)

	const isInApp =
		window.navigator.userAgent.includes('wv') ||
		window.navigator.userAgent.includes('WebView') ||
		window.navigator.userAgent.includes('webtoapp')

	//
	//MATT:  I sent over other params as well (from FilterByTeam), but it looks like o only need teamId
	//
	const teamId = useParams().teamId
	//console.log('useParams: ' + useParams())

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	//Get all games for a team.  getTeamSchedule2.  Also returns teamId.
	useEffect(() => {
		//console.log('INSIDE USE EFFECT')
		const sendRequest = async () => {
			setIsLoading(true)
			setAllTeamGames([])
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${teamId}`,
				)

				const responseData = await response.json()

				//console.log('responseData: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllTeamGames(responseData.allTeamGamesArray)
				setAllPotentialPlayoffGames(responseData.allPotentialPlayoffGamesArray)
				setAllGameStats(responseData.allGameStatsArray)
				//setTeamId(responseData.teamId)
				setTeamName(responseData.teamName)
				setWins(responseData.wins)
				setLosses(responseData.losses)
				setOvertimeLosses(responseData.overtimeLosses)
				setShootoutLosses(responseData.shootoutLosses)
				setTies(responseData.ties)
				setLeagueId(responseData.leagueId)
				setDivisionName(responseData.divisionName)
				setLeagueName(responseData.leagueName)
				setPimAsTieBreaker(responseData.pimAsTieBreaker)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [teamId])
	//
	//
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}
	//
	//
	//
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	let rem

	if (allTeamGames) {
		//console.log('assignedPlayers: ' + assignedPlayers)
		if (allTeamGames.length > 10) {
			rem = '2rem'
		} else {
			rem = '20rem'
		}
	}
	//
	//
	/* const calendarSubscribeHandler = () => {
		window.location.href = `${process.env.REACT_APP_BACKEND_URL}/admin/calendar/team/${teamId}.ics`
	} */

	//
	//
	/* const calendarSubscribeHandler = () => {
		const calendarUrl = `${process.env.REACT_APP_BACKEND_URL}/admin/calendar/team/${teamId}.ics`

		const webcalUrl = calendarUrl.replace(/^https?:\/\//, 'webcal://')

		alert(
			'iPhone users: Tap Find, then tap the red checkmark to sync this team schedule to your Calendar.',
		)

		window.location.href = webcalUrl
	} */
	//
	//
	const calendarSubscribeHandler = () => {
		setShowCalendarSyncModal(true)
	}
	//
	//
	const confirmCalendarSubscribeHandler = () => {
		const calendarUrl = `${process.env.REACT_APP_BACKEND_URL}/admin/calendar/team/${teamId}.ics`
		const webcalUrl = calendarUrl.replace(/^https?:\/\//, 'webcal://')

		setShowCalendarSyncModal(false)

		window.location.href = webcalUrl
	}
	//
	//
	const googleCalendarSubscribeHandler = () => {
		const calendarUrl = `${process.env.REACT_APP_BACKEND_URL}/admin/calendar/team/${teamId}.ics`

		window.location.href = `https://calendar.google.com/calendar/render?cid=${encodeURIComponent(
			calendarUrl,
		)}`
	}
	//
	//
	const getFormattedDate = (game) => {
		const month = game.date.substr(0, 2)
		const day = game.date.substr(3, 2)

		const monthMap = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${monthMap[month]} ${day}`
	}

	const getFormattedTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minutes = game.time.substr(3, 2)

		const hourMap = {
			'00': '12',
			'01': '1',
			'02': '2',
			'03': '3',
			'04': '4',
			'05': '5',
			'06': '6',
			'07': '7',
			'08': '8',
			'09': '9',
			10: '10',
			11: '11',
			12: '12',
			13: '1',
			14: '2',
			15: '3',
			16: '4',
			17: '5',
			18: '6',
			19: '7',
			20: '8',
			21: '9',
			22: '10',
			23: '11',
			24: '12',
		}

		const suffix = Number(hour) < 12 || hour === '24' ? 'AM' : 'PM'

		return `${hourMap[hour]}:${minutes} ${suffix}`
	}

	const getMobileScore = (game) => {
		if (!game.score) return ''

		const scoreParts = game.score.split('-').map((score) => score.trim())

		let scoreOnly = game.score

		if (scoreParts.length === 2) {
			const firstScore = scoreParts[0]
			const secondScore = scoreParts[1]

			if (game.winner === game.visitorTeamId) {
				scoreOnly = `${secondScore} - ${firstScore}`
			} else {
				scoreOnly = `${firstScore} - ${secondScore}`
			}
		}

		if (game.OTLHomeIsChecked || game.OTLVisitorIsChecked) {
			scoreOnly += ' (OT)'
		}

		return scoreOnly
	}

	const getWinningTeamClass = (game, team) => {
		if (!game.score) return ''

		const isWinner =
			(team === 'home' && game.winner === game.homeTeamId) ||
			(team === 'visitor' && game.winner === game.visitorTeamId)

		if (!isWinner) return ''

		const isPlayoff = game.playoff || game.championship || game.description

		return isPlayoff
			? 'mobileWinningTeam mobileWinningTeamPlayoff'
			: 'mobileWinningTeam'
	}

	const getTeamLogo = (teamName) => {
		if (!teamName) return null

		if (teamName.includes('Brookline')) return brookline
		if (teamName.includes('Cranberry')) return cranberry
		if (teamName.includes('Falcons')) return falcons
		if (teamName.includes('Bill')) return falcons
		if (teamName.includes('Latrobe')) return latrobe
		if (teamName.includes('McKeesport')) return mckeesport
		if (teamName.includes('Murrysville')) return murrysville
		if (teamName.includes('MDH')) return murrysville
		if (teamName.includes('New Ken')) return newKen
		if (teamName.includes('Penn Hills')) return pennHills
		if (teamName.includes('Arsenal')) return pennHills
		if (teamName.includes('Riverview')) return riverview
		if (teamName.includes('Raptors')) return riverview
		if (teamName.includes('Screaming')) return cranberry
		if (teamName.includes('South Hills')) return southHills
		if (teamName.includes('South Pgh')) return southHills
		if (teamName.includes('South Pittsburgh')) return southHills
		if (teamName.includes('Team Pitt')) return teamPitt
		if (teamName.includes('Venom')) return venom
		if (teamName.includes('Bridgeville')) return bridgeville
		if (teamName.includes('Egg Harbor')) return eggHarbor
		if (teamName.includes('GTHA')) return gtha
		if (teamName.includes('Leominster')) return leominster
		if (teamName.includes('Maple Shade')) return mapleShade
		if (teamName.includes('Marlton')) return marlton
		if (teamName.includes('Mays Landing')) return maysLanding
		if (teamName.includes('Medford')) return medfordRenegades
		if (teamName.includes('NY Menace')) return nymenace
		if (teamName.includes('Menace')) return nymenace
		if (teamName.includes('Scott')) return scottTownship
		if (teamName.includes('Dekhounds')) return scottTownship
		if (teamName.includes('West Deptford')) return westDeptford
		if (teamName.includes('Bellmawr')) return bellmawr
		if (teamName.includes('Athol')) return athol
		if (teamName.includes('Monroe')) return monroe
		if (teamName.includes('Fitchburg')) return fitchburg
		if (teamName.includes('Vipers')) return bridgeville
		if (teamName.includes('Vikings')) return southHills
		if (teamName.includes('Barbarians')) return southHills
		if (teamName.includes('Raiders')) return southHills
		if (teamName.includes('Gods')) return teamPitt
		if (teamName.includes('Eagles')) return cranberry
		if (teamName.includes('Team PA')) return pa
		if (teamName.includes('Tri County')) return tricounty
		if (teamName.includes('Tri-County')) return tricounty

		return null
	}

	const renderMobileScheduleCards = (games = []) => {
		return (
			<div className='mobileGameCards'>
				{games.map((game, key) => {
					const isPlayoffStyle =
						game.playoff || game.championship || game.description

					const homeLogo = getTeamLogo(game.homeTeamName)
					const visitorLogo = getTeamLogo(game.visitorTeamName)

					return (
						<div
							className={`mobileGameCard ${
								isPlayoffStyle ? 'mobileGameCardPlayoff' : ''
							}`}
							key={key}
						>
							<div className='mobileGameCardHeader'>
								<div>{getFormattedDate(game)}</div>

								<div className='mobileGameDivisionHeader'>
									<span>
										{game.playoff ? game.playoffDivision : divisionName}
									</span>

									{game.description && (
										<span className='mobileGameDescription'>
											{game.description}
										</span>
									)}
								</div>

								<div>{getFormattedTime(game)}</div>
							</div>

							<div className='mobileGameCardBody'>
								<div className='mobileGameTeam'>
									{homeLogo && (
										<img
											className='mobileGameTeamLogo'
											src={homeLogo}
											alt={game.homeTeamName}
										/>
									)}

									<div className={getWinningTeamClass(game, 'home')}>
										{game.homeTeamName}
										{game.noPointsForHomeTeam && ' (NP)'}
									</div>
								</div>

								{game.score ? (
									<div className='mobileGameScore'>
										{getMobileScore(game)}
										<span>Final</span>
									</div>
								) : (
									<div className='mobileGameScore mobileGameScoreEmpty'>
										<span>TBP</span>
									</div>
								)}

								<div className='mobileGameTeam'>
									{visitorLogo && (
										<img
											className='mobileGameTeamLogo'
											src={visitorLogo}
											alt={game.visitorTeamName}
										/>
									)}

									<div className={getWinningTeamClass(game, 'visitor')}>
										{game.visitorTeamName}
										{game.noPointsForVisitorTeam && ' (NP)'}
									</div>
								</div>
							</div>

							<div className='mobileGameVenue'>
								<span>📍 {game.venueName}</span>
							</div>
						</div>
					)
				})}
			</div>
		)
	}
	//
	//
	let dateBlock
	dateBlock = []
	if (!isLoading && leagueId && allTeamGames.length === 0) {
		return (
			<React.Fragment>
				<SchedulesHomeNavigation />
				<SelectLeagueSchedule />
				{/* <SearchByTeam leagueId={leagueId} /> */}
				<div style={{ marginBottom: '2rem' }}>
					<FilterByTeam leagueId={leagueId} />
				</div>
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (
		!isLoading &&
		leagueId &&
		allGameStats &&
		allGameStats.length > -1 &&
		allTeamGames.length !== 0
	) {
		dateBlock.push(
			<React.Fragment>
				<SelectLeagueSchedule />
				<div className='Schedule'>
					{/* <SearchByTeam leagueId={leagueId} /> */}
					<div style={{ marginBottom: '1rem' }}>
						<FilterByTeam leagueId={leagueId} />
					</div>
					<div className='teamScheduleDesktopHeader'>
						<h1>{teamName}</h1>
						<h4 style={{ textAlign: 'center', fontWeight: '600' }}>
							{divisionName + ' Division '}
						</h4>
						<h5 className='h3Center'>
							{allTeamGames[0].year + ' ' + allTeamGames[0].leagueName}
						</h5>
						<h5 className='h3Center'>
							Record: {wins} - {losses} -{' '}
							{ties + shootoutLosses + overtimeLosses}
						</h5>
					</div>

					<div className='teamScheduleMobileHero'>
						<div className='teamScheduleHeroTop'>
							<div className='teamScheduleHeroLine'></div>

							<div className='teamScheduleHeroIconCircle'>
								<img
									src={sLogo}
									alt='Shirey Logo'
									className='teamScheduleHeroLogo'
								/>
							</div>

							<div className='teamScheduleHeroLine'></div>
						</div>

						<h1>{teamName}</h1>

						<div className='teamScheduleDivisionPill'>
							{divisionName} Division
						</div>

						<div className='teamScheduleTournament'>
							{/* <FaCalendarAlt /> */}
							<span>
								{allTeamGames[0].year + ' ' + allTeamGames[0].leagueName}
							</span>
						</div>

						<div className='teamScheduleHeroDivider'></div>

						<div className='teamScheduleRecordLabel'>
							{/* <FaChartBar /> */}
							<span>Record</span>
						</div>

						<div className='teamScheduleRecordGrid4'>
							<div>
								<strong>{wins}</strong>
								<span>Wins</span>
							</div>

							<div>
								<strong>{losses}</strong>
								<span>Losses</span>
							</div>

							<div>
								<strong>{ties}</strong>
								<span>Ties</span>
							</div>

							<div>
								<strong>{overtimeLosses + shootoutLosses}</strong>
								<span>OTL</span>
							</div>
						</div>
					</div>
					{leagueName === 'McDevitt Cup' && (
						<div
							style={{
								textAlign: 'center',
								marginTop: '1rem',
								marginBottom: '1.5rem',
							}}
						>
							<a
								href='https://www.sporfie.com/gthapanthershockey'
								target='_blank'
								rel='noopener noreferrer'
								style={{
									fontSize: '1.1rem',
									fontWeight: '700',
									color: '#005bbb',
									textDecoration: 'none',
								}}
							>
								📺 Watch Live on Sporfie!
							</a>
						</div>
					)}
					{/* <h1>{teamName}</h1>
					<h4 style={{ textAlign: 'center', fontWeight: '600' }}>
						{divisionName + ' Division '}
					</h4>
					<h5 className='h3Center'>
						{allTeamGames[0].year + ' ' + allTeamGames[0].leagueName}
					</h5>
					<h5 className='h3Center'>
						Record: {wins} - {losses} - {ties + shootoutLosses + overtimeLosses}
					</h5>  */}
					{isIOS && isInApp && (
						<div className='teamCalendarSubscribeWrapper'>
							<button
								type='button'
								className='teamCalendarSubscribeButton'
								onClick={calendarSubscribeHandler}
								aria-label='Sync to Calendar'
								title='Sync to Calendar'
							>
								📅 Sync to Calendar
							</button>
						</div>
					)}
					{isInApp && isAndroid && (
						<div className='teamCalendarSubscribeWrapper'>
							<button
								type='button'
								className='teamCalendarSubscribeButton'
								onClick={googleCalendarSubscribeHandler}
								aria-label='Sync to Google Calendar'
								title='Sync to Google Calendar'
							>
								📅 Sync to Google Calendar
							</button>
						</div>
					)}
					<h4 className='mobileScheduleSectionTitle'>
						<span>Team Schedule</span>
					</h4>
					{/* <p>(Click on the final score of a game to see a Game Summary)</p> */}
					{isMobile && renderMobileScheduleCards(allTeamGames)}

					{!isMobile && (
						<table id='teamScheduleDisplay'>
							<thead>
								<tr>
									<th>Date/Time/Location</th>
									{/* <th>Time</th> */}
									{/* <th>Division</th> */}
									{/* <th>Score</th> */}
									<th>Opponent</th>
									<th>Score</th>
									{pimAsTieBreaker && <th>PIM</th>}
									<th>Pts.</th>
								</tr>
							</thead>
							<tbody>
								{allTeamGames.map((game, key) => {
									// if (game.venueName === venue) {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												{/* </td>
									<td> */}
												{', '}
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am '}

												<br></br>
												{' @ '}
												<br></br>
												{game.venueName}
												{((game.homeTeamId === teamId &&
													game.noPointsForHomeTeam) ||
													(game.visitorTeamId === teamId &&
														game.noPointsForVisitorTeam)) && (
													<div
														style={{
															color: 'red',
															fontWeight: 'bold',
															marginTop: '0.25rem',
														}}
													>
														NO POINTS GAME!
													</div>
												)}
											</td>
											{/* <td>
										{(game.status && game.status !== 'TBP' && (
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`/gameSummary/${game._id}`}
											>
												{game.status}
											</Link>
										)) ||
											'TBP'}
									</td> */}

											{game.homeTeamName === teamName && (
												<td>
													{game.visitorTeamName}
													{game.noPointsForVisitorTeam && ' (NP)'}
													{game.description && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															{'('}
															{game.description}
															{')'}
														</div>
													)}
												</td>
											)}
											{game.visitorTeamName === teamName && (
												<td>
													@ {game.homeTeamName}
													{game.noPointsForHomeTeam && ' (NP)'}
													{game.description && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															{'('}
															{game.description}
															{')'}
														</div>
													)}
												</td>
											)}
											{/* <td>
										{game.visitorTeamSeed > 0 &&
											'(' + game.visitorTeamSeed + ') '}
										{game.visitorTeamName && game.visitorTeamName}
										{' @ '}
										{game.homeTeamSeed > 0 && '(' + game.homeTeamSeed + ') '}
										{game.homeTeamName && game.homeTeamName}
									</td> */}
											{!game.score && <td></td>}
											{game.score && !game.winner && !game.loser && (
												<td style={{ color: 'black', fontWeight: '600' }}>
													{/* <Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`/gameSummary/${game._id}`}
											>
												TIED {game.score}
											</Link> */}
													TIED {game.score}
												</td>
											)}
											{game.loser === teamId && (
												<td style={{ color: 'red', fontWeight: 'bold' }}>
													{/* <Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'red',
												}}
												to={`/gameSummary/${game._id}`}
											>
												LOST {game.score}
											</Link> */}
													LOST {game.score}
													{game.OTLHomeIsChecked && ' (OT)'}
													{game.OTLVisitorIsChecked && ' (OT)'}
												</td>
											)}
											{game.winner === teamId && (
												<td style={{ color: 'green', fontWeight: 'bold' }}>
													WON {game.score}
													{game.OTLHomeIsChecked && ' (OT)'}
													{game.OTLVisitorIsChecked && ' (OT)'}
												</td>
											)}
											{game.homeTeamId === teamId &&
												pimAsTieBreaker &&
												allGameStats[key] !== null && (
													<td>
														{JSON.stringify(allGameStats[key].homePimTotal)}
													</td>
												)}
											{game.visitorTeamId === teamId &&
												pimAsTieBreaker &&
												allGameStats[key] !== null && (
													<td>
														{JSON.stringify(allGameStats[key].visitorPimTotal)}
													</td>
												)}
											{game.homeTeamId === teamId &&
												allGameStats[key] !== null && (
													<td>
														{JSON.stringify(
															allGameStats[key].homePointsAwarded,
														)}
													</td>
												)}
											{game.visitorTeamId === teamId &&
												allGameStats[key] !== null && (
													<td>
														{JSON.stringify(
															allGameStats[key].visitorPointsAwarded,
														)}
													</td>
												)}
											{allGameStats[key] === null && <td></td>}
										</tr>
									)
									//}
								})}
							</tbody>
						</table>
					)}
				</div>
				<div className='Schedule'>
					<h4 className='mobileScheduleSectionTitle'>
						<span>{divisionName} Playoff Games</span>
					</h4>
					{isMobile &&
						renderMobileScheduleCards(allPotentialPlayoffGames || [])}

					{!isMobile && (
						<table id='teamScheduleDisplay'>
							<thead>
								<tr>
									<th>Date/Time/Location</th>
									<th>Visitor/Home</th>
									<th></th>
									<th>Winner</th>
									<th>Score</th>
								</tr>
							</thead>
							<tbody>
								{allPotentialPlayoffGames.map((game, key) => {
									// if (game.venueName === venue) {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												{/* </td>
									<td> */}
												{', '}
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am '}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm '}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am '}
												{/* </td>
									<td> */}
												<br></br>
												{' @ '}
												<br></br>
												{game.venueName}
											</td>
											{/* //
										//
										//    Visitor/Home
										//
										// */}
											{game.visitorTeamName && (
												<td>
													{game.visitorTeamName && game.visitorTeamName}
													{game.noPointsForVisitorTeam && ' (NP)'}
													<br></br>
													{' @ '}
													<br></br>
													{game.homeTeamName && game.homeTeamName}
													{game.noPointsForHomeTeam && ' (NP)'}
													{game.description && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															{'('}
															{game.description}
															{')'}
														</div>
													)}
												</td>
											)}
											{game.description && <td></td>}

											{/* //
										//
										//    Winner
										//
										// */}
											{game.homeTeamId && game.winner === game.homeTeamId && (
												<td>{game.homeTeamName}</td>
											)}
											{game.visitorTeamId &&
												game.winner === game.visitorTeamId && (
													<td>{game.visitorTeamName}</td>
												)}
											{game.status &&
												game.status !== 'TBP' &&
												game.winner !== game.homeTeamId &&
												game.winner !== game.visitorTeamId && <td>TIE</td>}
											{!game.score && <td></td>}
											{/* //
										//
										//    Score
										//
										// */}
											<td
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
											>
												{game.score}
											</td>
										</tr>
									)
									//}
								})}
							</tbody>
						</table>
					)}
				</div>
			</React.Fragment>,
		)
		// }
		//)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation />
				{showCalendarSyncModal && (
					<div className='calendarSyncBackdrop'>
						<div className='calendarSyncModal'>
							<h2>Sync to iPhone Calendar</h2>

							<p>
								Your team&apos;s schedule, including potential playoff games,
								will be added to your iPhone Calendar.
							</p>

							<p>
								On the next screen, tap <strong>Find</strong>, then tap the{' '}
								<strong>red checkmark</strong>.
							</p>

							<div className='calendarSyncModalActions'>
								<button
									type='button'
									className='calendarSyncCancelButton'
									onClick={() => setShowCalendarSyncModal(false)}
								>
									Cancel
								</button>

								<button
									type='button'
									className='calendarSyncContinueButton'
									onClick={confirmCalendarSubscribeHandler}
								>
									Open Calendar
								</button>
							</div>
						</div>
					</div>
				)}

				{dateBlock && dateBlock}

				<div style={{ marginTop: '8rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		</div>
	)
}

export default TeamSchedule
